/* @ngInject */

import { FEATURES, USER_CLAIMS, capitalize, canPerformAction, shouldBeEnabled } from '../../common';

export default class DashboardCtrl {
    constructor(
        $q,
        $http,
        $scope,
        $window,
        Utility,
        $timeout,
        $interval,
        $location,
        $rootScope,
        UserUnitsService,
        DashboardService,
        BuildingsService,
        NavigationService,
        LocalStorageService,
        AuthorizationService,
        AuthenticationService
    ) {
        this.$q = $q;
        this.$http = $http;
        this.$scope = $scope;
        this.$window = $window;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.$location = $location;
        this.$rootScope = $rootScope;
        this.UserUnitsService = UserUnitsService;
        this.DashboardService = DashboardService;
        this.BuildingsService = BuildingsService;
        this.NavigationService = NavigationService;
        this.LocalStorageService = LocalStorageService;
        this.AuthorizationService = AuthorizationService;
        this.AuthenticationService = AuthenticationService;

        this.init();
    }

    init() {
        this.isBusy = true;
        this.timeoutPromise;
        this.buildings = [];
        this.userUnits = [];
        this._timeoutProcess;
        this.loginEmail = '';
        this.portfolioCount = 0;
        this.timeoutDelay = 1500;
        this.paymentApprovedCount = 0;
        this._timeoutProcessRetry = 0;
        this.selectedBuildingRef = undefined;
        this.selectedBuilding = undefined;
        this.buildingFeatureSetting = null;
        this.shouldBeEnabled = shouldBeEnabled;
        this.canPerformAction = canPerformAction;
        this.dashboardMenuText = 'Please make your selection on the left';

        this.busyProcesses = {
            mainProcess: {
                show: false,
                count: 0
            },
            subProcesses: {
                approvals: { isBulk: false, payments: [] },
                bands: { isApproving: false, isQuerying: false }
            }
        };

        this.tiles = [];
        this.staticTiles = [
            {
                address: '',
                front: {
                    mode: 'single',
                    title: 'More Coming Soon...😀',
                    value: '',
                    styles: {
                        title: {
                            'margin-top': '3.5em'
                        },
                        subtitle: {}
                    }
                }
            }
        ];

        this.buildStaticTiles();

        this._handleEvents();

        this.$timeout(async () => {
            this._switchIsBusy(true);
            await this.activate();

            this.$timeout(() => {
                this._switchIsBusy(false);
            }, 800);
        });
    }

    buildStaticTiles() {
        if (this.shouldBeEnabled(USER_CLAIMS.MY_PROFILE)) {
            this.staticTiles.push({
                address: FEATURES.MY_PROFILE,
                front: {
                    mode: 'single',
                    title: 'Update My Details',
                    value: '',
                    styles: {
                        title: {
                            'margin-top': '3.5em'
                        },
                        subtitle: {}
                    }
                }
            });
        }

        this.staticTiles.push({
            address: FEATURES.PERSONAL_DOCUMENTS,
            front: {
                mode: 'single',
                title: 'Personal Documents',
                value: '',
                styles: {
                    title: {
                        'margin-top': '3.5em'
                    },
                    subtitle: {}
                }
            }
        });

        if (this.shouldBeEnabled(USER_CLAIMS.REGISTER_TENANT)) {
            this.staticTiles.push({
                address: FEATURES.TENANT,
                front: {
                    mode: 'single',
                    title: 'My Tenant',
                    value: '',
                    styles: {
                        title: {
                            'margin-top': '3.5em'
                        },
                        subtitle: {}
                    }
                }
            });
        }
    }

    get defaultPayments() {
        return {
            address: FEATURES.PAYMENTS,
            front: {
                mode: 'single',
                title: 'Payments',
                value: 0,
                styles: {
                    subtitle: {
                        primary: {},
                        secondary: { 'font-size': '50pt' }
                    },
                    title: {
                        'font-size': '20pt',
                        'margin-top': '1.5em'
                    },
                    self: {
                        display: 'flex',
                        'flex-direction': 'column'
                    }
                }
            },
            back: {
                title: 'Payments',
                styles: {
                    title: null,
                    self: {
                        display: 'flex',
                        'flex-direction': 'column'
                    }
                },
                value: []
            }
        };
    }

    get newDefaultPayments() {
        return {
            address: FEATURES.PAYMENTS,
            front: {
                mode: 'multiple-subtitles',
                title: [],
                value: 'R 0.00',
                styles: {
                    title: {
                        'margin-top': '0.7em'
                    },
                    subtitle: {
                        primary: {
                            'font-size': '18pt',
                            'margin-top': '2em',
                            display: 'inline-block',
                            'font-weight': 'bolder',
                            'text-transform': 'capitalize'
                        },
                        secondary: {
                            'font-size': '50pt'
                        }
                    },
                    self: {
                        display: 'flex',
                        'flex-direction': 'column'
                    }
                }
            },
            back: {
                mode: 'multiple-subtitles',
                title: 'Awaiting Approval',
                styles: {
                    title: {
                        'font-size': '26pt',
                        'margin-top': '0.7em'
                    },
                    self: {
                        display: 'flex',
                        'flex-direction': 'column'
                    }
                },
                value: []
            }
        };
    }

    get defaultAccountHistory() {
        return {
            address: FEATURES.VIEW_ACCOUNTS_HISTORY,
            front: {
                mode: 'multiple-subtitles',
                title: ['Account Balance', ''],
                value: 'R 0.00',
                styles: {
                    title: {
                        'margin-top': '0.7em'
                    },
                    subtitle: {
                        primary: {
                            'font-size': '18pt',
                            'margin-top': '2em',
                            display: 'inline-block',
                            'font-weight': 'bolder'
                        },
                        secondary: {}
                    },
                    self: {
                        display: 'flex',
                        'flex-direction': 'column'
                    }
                }
            },
            back: {
                mode: 'multiple-subtitles',
                title: 'Monthly Charges',
                styles: {
                    title: {
                        'font-size': '26pt',
                        'margin-top': '0.7em'
                    },
                    self: {
                        display: 'flex',
                        'flex-direction': 'column'
                    }
                },
                value: []
            }
        };
    }

    async _handleUserUnitsLoad(event, schemeName) {

        if (schemeName) {
            const building = this.BuildingsService.buildingsData.allBuildings.find((building) => {
                const { SchemeName } = building;
                const found = SchemeName === schemeName;
                return found;
            });
            const { SchemeReference: schemeRef } = building;

            for (let index = 0; index < this.staticTiles.length; index++) {
                const element = this.staticTiles[index];
                element.value = schemeRef;
            }
            if (!!!this.loginEmail) {
                await this.loadMasterEmail();
            }
            const units = await this.DashboardService.getUserUnitsInformation(schemeRef, this.loginEmail);
            this.userUnits = units;
            this.getBuildingBackground(schemeRef);
        }
    }

    async loadMasterEmail() {
        this._switchIsBusy(true);
        try {
            const userProfile = this.LocalStorageService.retrieve('userProfile');
            if (userProfile && userProfile != null && 'UserName' in userProfile) {
                const { UserName: username } = userProfile;
                const results = await this.DashboardService.getMasterEmail(username);
                this.loginEmail = results;
            }
        } catch (error) {
            this.NotificationService.error(`Error while loading profile information.`);
            console.error(error);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async _handleBuildingChanged(event, schemeRef, oldSchemeRef) {
        let units;
        this._switchIsBusy(true);
        try {
            if (schemeRef !== oldSchemeRef) {
                if (!!schemeRef) {
                    if (!!!this.loginEmail) {
                        await this.loadMasterEmail();
                    }
                    this.selectedBuildingRef = schemeRef;
                    units = await this.DashboardService.getUserUnitsInformation(schemeRef, this.loginEmail);
                }
                this.userUnits = units;
            }
        } catch (error) {
            console.error(error);
        } finally {
            this._switchIsBusy(false);
        }
    }

    getBuildingBackground(buildingRef) {
        const deferred = this.$q.defer(),
            promise = deferred.promise;

        const fallbackUrl =
            PretorCDNAddress +
            (_.endsWith(PretorCDNAddress, '/') ? '' : '/') +
            'images/buildings/default_bg.png';

        const url = this.BuildingsService.getTrustedBuildingImageUrl(buildingRef);

        this.$http.get(url).then(
            () => {
                deferred.resolve(url);
            },
            (err) => {
                deferred.resolve(fallbackUrl);
            }
        );

        return promise;
    }

    _handleEvents() {
        this.$scope.$on('reload-user-units', (event, data) => {
            //$("MainVM").context.all.selectedBuildingTitle.innerText = building.SchemeName;	
            this._handleUserUnitsLoad(event, data);
        });
        this.$scope.$on('selected-building-changed', (event, newVal, oldVal) => {
            if (!this.isBusy) {
                this._handleBuildingChanged({}, newVal, oldVal);
            }
        });
        this.$rootScope.$on('user-logged-in', async ($event, results) => {
            const profile = results && results.length > 0 ? results[1] : results;

            await this._handleDefaultSchemeRef(profile);
            this.$rootScope.$broadcast('show-register-prompt-auth-modal', profile);

            if (
                this.selectedBuildingRef &&
                ((typeof this.selectedBuildingRef == 'string' && this.selectedBuildingRef.trim().length == 3) ||
                    this.selectedBuildingRef.hasOwnProperty('SchemeReference'))
            ) {
                this.$rootScope.$broadcast('force-data-reload', this.selectedBuildingRef);
            }
        });

        this.$scope.$watch(
            'DashboardVM.busyProcesses.mainProcess.show',
            (newValue, oldValue) => {
                const isBusyLastShownStr = this.LocalStorageService.retrieve('isBusyLastShown');
                const time = this.Utility.apiRetry.value;

                if (!isBusyLastShownStr) {
                    if (!this._timeoutProcess) {
                        this._timeoutProcess = this.$timeout(() => {
                            this.busyProcesses.mainProcess = {
                                show: false,
                                count: 0
                            };

                            this.LocalStorageService.save(
                                'isBusyLastShown',
                                moment(new Date()).format(this.Utility.dateTimeFormat)
                            );

                            const buildingRef = this.LocalStorageService.retrieve('selectedBuildingRef');

                            this._timeoutProcess = undefined;
                            this.$rootScope.$broadcast('force-data-reload', buildingRef);
                        }, time * 1.3);
                    }
                }
            },
            true
        );
    }

    unitBalance(unit) {
        const mapped =
            unit.Balance == 0 ? 'Account Up to date' : 'Account Balance ' + 'R ' + unit.Balance.toFixed(2).toString();
        return mapped;
    }

    async activate() {
        let promise,
            promises = [],
            promiseHandler;
        let units;
        promise = new Promise((resolve, reject) => {
            promiseHandler = {
                reject,
                resolve
            };
        });

        this.LocalStorageService.save('mainProcessesDone', false);
        try {
            this._switchIsBusy(true);
            this.setSelectedInitialDBRef();
            //Getting selectedBuildingRef from building service 
            this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
            await this.loadMasterEmail();
            if (this.selectedBuildingRef && this.selectedBuildingRef != null) {
                units = await this.DashboardService.getUserUnitsInformation(this.selectedBuildingRef, this.loginEmail);
                this.userUnits = units;
            }
        } catch (error) {
            this.$timeout(() => promiseHandler.reject(error));
        }
        finally {
            this._switchIsBusy(false);
        }

        return promise;
    }

    async loadTilesData() {
        let promise, promiseHandler;

        promise = new Promise((resolve, reject) => {
            promiseHandler = {
                reject,
                resolve
            };
        });
        try {
            this.$timeout(async () => {
                let promises = [];
                if (this.canPerformAction(USER_CLAIMS.APPROVE_PAYMENTS)) {
                    const promise = await this.getPaymentsTileData();
                    promises.push(promise);
                }

                if (this.shouldBeEnabled(USER_CLAIMS.VIEW_ACCOUNTS_HISTORY)) {
                    const promise = await this.getAccountHistoryTileData();
                    promises.push(promise);
                }

                this.$timeout(async () => {
                    await Promise.all(promises);
                    promiseHandler.resolve();
                });
            });
        } catch (error) {
            this.$timeout(() => promiseHandler.reject(error));
        }

        return promise;
    }

    async getPaymentsTileData() {
        let promise, promiseHandler;

        promise = new Promise((resolve, reject) => {
            promiseHandler = {
                reject,
                resolve
            };
        });
        try {
            const buildings = this.BuildingsService.buildingsData.allBuildings;
            for (let index = 0; index < buildings.length; index++) {
                const building = buildings[index];
                const { SchemeName: scheme, SchemeReference: schemeRef } = building;

                const userCanPerformAction = this.canPerformAction(USER_CLAIMS.APPROVE_PAYMENTS, schemeRef);
                const isDashboardEnabled = this.shouldBeEnabled(FEATURES.PAYMENTS, true)

                if (!isDashboardEnabled || !userCanPerformAction) {
                    if (index === buildings.length - 1) {
                        this.$timeout(() => promiseHandler.resolve());
                        continue;
                    } else {
                        continue;
                    }
                }

                let results = await this.DashboardService.getPayments(schemeRef);
                const { Data: data, NumberOfResults: noOfPayments } = results;

                let tile = this.newDefaultPayments;
                tile.address = `${FEATURES.PAYMENTS}?dbRef=${schemeRef}`;
                tile.front.value = noOfPayments;
                tile.front.title = ['Payments', capitalize(scheme)];

                data.map((dashboardPayment) => {
                    const { title, value } = dashboardPayment;
                    if (value && value > 0) {
                        tile.back.value = [...tile.back.value, { title, value: parseFloat(value).toFixed(2) }];
                    } else {
                        tile.back.value = 0;
                    }
                });
                this.tiles = [tile, ...this.tiles];

                if (index === buildings.length - 1) {
                    this.$timeout(() => promiseHandler.resolve());
                }
            }
        } catch (error) {
            console.error(`Error while loading payments' tile data:\n${JSON.stringify(error)}`);
            this.$timeout(() => promiseHandler.reject(error));
        }

        return promise;
    }

    async getAccountHistoryTileData() {
        let promise,
            promises = [],
            promiseHandler;

        promise = new Promise((resolve, reject) => {
            promiseHandler = {
                reject,
                resolve
            };
        });

        try {
            const buildingsWithUnits = await this.UserUnitsService.getFriendlyUnitNamesWithUserBuildingNames();
            promises.push(buildingsWithUnits);
            this.tiles = this.tiles.filter((tile) => !tile.address.includes(FEATURES.VIEW_ACCOUNTS_HISTORY));
            buildingsWithUnits.forEach(async (building) => {
                try {
                    for (let index = 0; index < building.units.length; index++) {
                        const unitCardCode = building.units[index];

                        if (!unitCardCode.includes('9999')) {
                            const results = await this.DashboardService.getAccountHistory(unitCardCode);

                            promises.push(results);
                            let newTile = this.defaultAccountHistory;
                            newTile = {
                                address: `${FEATURES.ACCOUNT_HISTORY}?cardCode=${unitCardCode}`,
                                front: {
                                    ...newTile.front,
                                    ...results.front
                                },
                                back: {
                                    ...newTile.back,
                                    ...results.back
                                }
                            };

                            this.tiles = [...this.tiles, newTile];
                        }
                        if (index === building.units.length - 1) {
                            this.$timeout(() => promiseHandler.resolve(), 800);
                        }
                    }
                } catch (error) {
                    throw error;
                }
            });

            await promises;
            this.$timeout(() => promiseHandler.resolve());
        } catch (error) {
            console.error(`Error while loading account history's tile data:\n${JSON.stringify(error)}`);

            this.$timeout(() => promiseHandler.reject(error));
        } finally {
            this._switchIsBusy(false);
        }

        return promise;
    }

    setTileData(index, tileData) {
        this.tiles[index].back.value = tileData.Data;
        this.tiles[index].front.value = tileData.Data.length;
    }

    async _handleDefaultSchemeRef(profile) {
        const storedRef = this.LocalStorageService.retrieve('selectedBuildingRef');
        if (this.NavigationService.navigationData.selectedBuildingRef) {
            await this._mapSchemeRefToObj(this.NavigationService.navigationData.selectedBuildingRef.toUpperCase());
        } else if (storedRef && typeof storedRef != 'object') {
            await this._mapSchemeRefToObj(storedRef.toUpperCase());
        }

        if (
            !this.selectedBuildingRef ||
            (this.selectedBuildingRef &&
                typeof this.selectedBuildingRef === 'object' &&
                !this.selectedBuildingRef.hasOwnProperty('SchemeReference')) ||
            (this.selectedBuildingRef &&
                typeof this.selectedBuildingRef === 'string' &&
                this.selectedBuildingRef.trim().length != 3)
        ) {
            if (profile && (profile.BuildingProfiles && profile.BuildingProfiles.length > 1)) {
                var sorted = _.sortBy(profile.BuildingProfiles, [
                    (bp) => {
                        return bp.SchemeName;
                    }
                ]);
                this.selectedBuildingRef = sorted[0];
            } else if (profile) {
                this.selectedBuildingRef = profile.BuildingProfiles[0];
            }
        }

        let defaultDbRef;
        if (this.selectedBuildingRef && typeof this.selectedBuildingRef === 'object') {
            defaultDbRef = this.selectedBuildingRef.SchemeReference.trim();
            this.$rootScope.$emit('selected-building-changed', defaultDbRef);
        } else {
            defaultDbRef = this.selectedBuildingRef.trim();
        }

        this.$rootScope.$broadcast('set-selected-scheme-active', defaultDbRef);
    }

    async _mapSchemeRefToObj(schemeRef) {
        const deferred = this.$q.defer();
        const promise = deferred.promise;

        try {
            const buildingResult = await this.BuildingsService.loadBySchemeRef(schemeRef.toUpperCase());

            this.selectedBuildingRef = buildingResult;
            deferred.resolve(buildingResult);
        } catch (err) {
            deferred.reject(err);
        }

        return promise;
    }

    async setSelectedInitialDBRef() {
        if (
            this.NavigationService &&
            !this.NavigationService.navigated &&
            this.NavigationService.navigationData.selectedBuildingRef
        ) {
            await this.loadSelectedInitialScheme();

            this.selectedBuildingRef = this.NavigationService.navigationData.selectedBuildingRef.toUpperCase().trim();
            this.NavigationService.navigate();
        } else if (
            this.BuildingsService &&
            this.BuildingsService.buildingsData &&
            this.BuildingsService.buildingsData.hasOwnProperty('selectedBuilding')
        ) {
            if (typeof this.BuildingsService.buildingsData.selectedBuilding === 'object') {
                this.selectedBuildingRef = this.BuildingsService.buildingsData.selectedBuilding.SchemeReference.trim();
            } else {
                this.selectedBuildingRef = this.BuildingsService.buildingsData.selectedBuilding;
            }
        }
    }

    async loadSelectedInitialScheme() {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });
            const currentUser = this.LocalStorageService.retrieve('userProfile');
            if (!currentUser) {
                this.$scope.$on('user-logged-in', ($event, results) => {
                    this.$timeout(() => promiseHandler.resolve(results[1]));
                });
            } else {
                this.$timeout(() => promiseHandler.resolve(currentUser));
            }
        } catch (error) {
            this.$timeout(() => promiseHandler.reject(error));
        }

        return promise;
    }

    isActive(tabNumber) {
        const selectedTab =
            this.NavigationService.navigationData && this.NavigationService.navigationData.selectedTab
                ? this.NavigationService.navigationData.selectedTab
                : '1';
        return tabNumber == selectedTab;
    }

    _paymentChanged(body, id, type) {
        if (body) {
            this.busyProcesses.subProcesses.approvals.payments.push({
                key: id,
                value: body
            });
            this.$rootScope.$broadcast('payment-is-busy', id, type);
        } else {
            let indexFound;
            this.busyProcesses.subProcesses.approvals.payments.forEach((process, index) => {
                if (process.key == id) {
                    indexFound = index;
                    return false;
                }
            });
            if (indexFound) {
                this.busyProcesses.subProcesses.approvals.payments.splice(indexFound, 1);
                this.$rootScope.$broadcast('payment-is-done', id, type);
            }
        }
    }

    _mainProcessChanged(body, id) {
        let count = this.busyProcesses.mainProcess.count ? this.busyProcesses.mainProcess.count : 0;
        if (body) {
            count = count + 1;
        } else {
            count = count - 1;
        }
        this.busyProcesses.mainProcess = {
            show: count <= 0 ? false : true,
            count: count < 0 ? 0 : count
        };
    }

    hasAccess(claim) {
        const isAllowed = this.AuthorizationService.isAuthorized(claim);
        return isAllowed;
    }

    _setBuildingBackground(buildingRef) {
    }

    _switchIsBusy(flag) {
        this.$timeout(() => {
            this.isBusy = flag;
        });
    }
}
